import React, { useState } from "react";
import { Grid, Box, Tabs, Tab, Button, Typography } from "@mui/material";
import Sidebar from "../../components/Sidebar/Sidebar";
import Header from "../../components/Header/Header";
import QuestionnaireList from "../../components/QuestionnaireList/QuestionnaireList";
import QuestionnaireAssignments from "../../components/QuestionnaireAssignments/QuestionnaireAssignments";
import QuestionnaireResponses from "../../components/QuestionnaireResponses/QuestionnaireResponses";
import CreateQuestionnaireModal from "../../components/CreateQuestionnaireModal/CreateQuestionnaireModal";
import styles from "./QuestionairesPageStyles";

const Questionnaires: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const handleCreateOpen = () => setIsCreateModalOpen(true);
  const handleCreateClose = () => setIsCreateModalOpen(false);

  return (
    <Grid container sx={styles.QuestionairesContainer}>
      <Grid item xs={2.5}>
        <Sidebar />
      </Grid>
      <Grid item xs={9}>
        <Header />
        <Box sx={styles.QuestionairesContent}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography variant="h4" fontWeight="bold">
              Questionnaires
            </Typography>
            <Button
              variant="contained"
              onClick={handleCreateOpen}
              sx={styles.createButton}
            >
              Create New Questionnaire
            </Button>
          </Box>
          <Tabs value={activeTab} onChange={handleTabChange} sx={styles.tabs}>
            <Tab label="Questionnaires" />
            <Tab label="Assignments" />
            <Tab label="Responses" />
          </Tabs>
          {activeTab === 0 && <QuestionnaireList />}
          {activeTab === 1 && <QuestionnaireAssignments />}
          {activeTab === 2 && <QuestionnaireResponses />}
        </Box>
      </Grid>
      <CreateQuestionnaireModal
        open={isCreateModalOpen}
        onClose={handleCreateClose}
      />
    </Grid>
  );
};

export default Questionnaires;
